export const categoriesProvider = (floorConfig) =>
  Object.keys(floorConfig).map((locationKey) => ({
    key: floorConfig[locationKey].locationKey,
    section: floorConfig[locationKey].section,
    floor: floorConfig[locationKey].floor,
    sectionKey: floorConfig[locationKey].sectionKey,
    floorKey: floorConfig[locationKey].floorKey,
  }));
